export const HOW_IT_WORKS_ANCHOR = "how-it-works";
export const FAQ_ANCHOR = "faq";

export const STORAGE_SHARE_LINK_KEY = "shareLink";
export const STORAGE_EMAIL_KEY = "userEmail";

export const BOTTOM_BAR_CHECKMARKS = [
  "recommend_airhelp_easy_to_share",
  "recommend_airhelp_expert_assistance",
  "recommend_airhelp_everyone_wins",
];

export const MENU_LINKS = [
  {
    href: `#${HOW_IT_WORKS_ANCHOR}`,
    title: "menu_how_it_works",
  },
  {
    href: `#${FAQ_ANCHOR}`,
    title: "menu_faq",
    hasMobileMarginTop: true,
    removeDesktopMarginRight: true,
  },
];

export const HOW_IT_WORKS_ITEMS = [
  {
    _uid: "1",
    icon: "NumberOneIcon",
    heading: "how_it_works_you_share",
    text: "how_it_works_you_share_description",
  },
  {
    _uid: "2",
    icon: "NumberTwoIcon",
    heading: "how_it_works_your_friends_submit",
    text: "how_it_works_your_friends_submit_description",
  },
  {
    _uid: "3",
    icon: "NumberThreeIcon",
    heading: "how_it_works_you_get_money",
    text: "how_it_works_you_get_money_description",
  },
];
